import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import { Traducciones } from "@locale";
import { TraduccionesToken } from "@shared/tokens";
import { formatTraducir } from "@shared/utils";

@Pipe({
    name: "traducir"
})
export class TraducirPipe implements PipeTransform {
    constructor(@Inject(TraduccionesToken) private traducciones: Traducciones,
        @Inject(LOCALE_ID) private localeId: string) {}

    transform(claveTraducir: string): string {
        return formatTraducir(this.traducciones, claveTraducir, this.localeId);
    }

}
